@let isEditingParams =
  recordsEc.plugins.currentListPlugin.feature.selectors.isEditingParams.asSignal();

<atn-ds-page>
  <atn-ds-table
    class="atn-space-records-list"
    [config]="tableConfig"
  >
    <div customTools>
      <i
        class="atn-icon atn-funnel atn-blue"
        [class.atn-space-records-list__icon-with-info]="hasAppliedParamsSg()"
        (click)="filtersClickHandler()"
      ></i>
    </div>
  </atn-ds-table>
</atn-ds-page>

@if (isEditingParams) {
  <atn-space-lite-record-filters />
}
